export const FILTER_TYPES = {
  DROP_DOWN: 'dropdown',
  BOOLEAN: 'boolean',
  DATE: 'date',
  ADVANCE_INPUT: 'advance_input',
};

export const FILTER_KEY_TYPES_SLUGS = {
  EQUAL: 'eq',
  GREATER_THEN: 'gt',
  LESS_THEN: 'lt',
  CONTAINS: 'notnull',
  NULL: 'null',
};

export const FILTER_KEY_TYPES_SLUGS_ARR = [
  FILTER_KEY_TYPES_SLUGS.EQUAL,
  FILTER_KEY_TYPES_SLUGS.GREATER_THEN,
  FILTER_KEY_TYPES_SLUGS.LESS_THEN,
  FILTER_KEY_TYPES_SLUGS.CONTAINS,
  FILTER_KEY_TYPES_SLUGS.NULL,
];

export const FILTER_TYPES_OPTIONS = [
  {
    key: 1,
    label: 'Is Equal',
    value: FILTER_KEY_TYPES_SLUGS.EQUAL,
  },
  {
    key: 2,
    label: 'Greater than',
    value: FILTER_KEY_TYPES_SLUGS.GREATER_THEN,
  },
  {
    key: 3,
    label: 'Less than',
    value: FILTER_KEY_TYPES_SLUGS.LESS_THEN,
  },
  {
    key: 4,
    label: 'Is Present',
    value: FILTER_KEY_TYPES_SLUGS.CONTAINS,
    defaultValue: 'true',
  },
  {
    key: 5,
    label: 'Is Not Present',
    value: FILTER_KEY_TYPES_SLUGS.NULL,
    defaultValue: 'true',
  },
];

export const FILTER_DISPLAY_VALUE = (value) => ({
  [FILTER_KEY_TYPES_SLUGS.EQUAL]: value,
  [FILTER_KEY_TYPES_SLUGS.GREATER_THEN]: `> ${value}`,
  [FILTER_KEY_TYPES_SLUGS.LESS_THEN]: `< ${value}`,
  [FILTER_KEY_TYPES_SLUGS.CONTAINS]: 'contains',
  [FILTER_KEY_TYPES_SLUGS.NULL]: 'not contains',
});

// _eq i.e exactly equal
// _not_eq i.e is not equal
// _cont i.e contains
// _null = false i.e is present
// _null = true i.e not present
